const companyPotential = {
    number: "1/2",
    question: "What will your company look like when it's reached its full potential?",
    description: `When you think of what your company is going to look like when it has reached its full potential,
                                what will it look like? This could be a specific quantitative or qualitative goal of the next 5, 10 or 50 years.
                                The easiest way to do this is to start the sentence with: "To be…" and fill the rest of the sentence with the goal.`
}

const worldPotential = {
    number: "2/2",
    question: `What will the world look like when your company
                                has reached its full potential?`,
    description: `As your company has reached that goal, and its full effects have taken on in the world, what will the world look like?
                                The easiest way to do this is to start the sentence with: "When we've reached our full potential, the world will…"`                             
}


export const questions = {
    companyPotential: companyPotential,
    worldPotential: worldPotential,
}

const companyPotentialVideo = {
    url: "https://www.dropbox.com/scl/fi/yhnd48kaa0s4j246gsbcz/17-The-Vision.mp4?rlkey=vl5fhsvsotxvwzskprbdye9wr&raw=1"
}

const worldPotentialVideo = {
    url: "https://www.dropbox.com/scl/fi/yhnd48kaa0s4j246gsbcz/17-The-Vision.mp4?rlkey=vl5fhsvsotxvwzskprbdye9wr&raw=1"
}

export const videos = {
    companyPotentialVideo: companyPotentialVideo,
    worldPotentialVideo: worldPotentialVideo
}